import { render, staticRenderFns } from "./NetGsmCDR.vue?vue&type=template&id=958577a8&scoped=true"
import script from "./NetGsmCDR.vue?vue&type=script&lang=js"
export * from "./NetGsmCDR.vue?vue&type=script&lang=js"
import style0 from "./NetGsmCDR.vue?vue&type=style&index=0&id=958577a8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "958577a8",
  null
  
)

export default component.exports